// PWA 相關的畫面（GDO-21）：離線提示、新版本提示、安裝按鈕。
import type { Manifest } from '@dayone/core/snapshot';
import { t } from '../../i18n/zh-TW.ts';
import type { Pwa } from '../../pwa/usePwa.ts';
import { Hint } from '../../ui/Hint.tsx';
import { Download, ICON, RefreshCw, WifiOff } from '../../ui/icons/index.ts';

const timeFormat = new Intl.DateTimeFormat('zh-TW', {
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

/** 頁面頂端的離線提示：說明目前顯示的是哪個時間的資料 */
export function OfflineBanner({ manifest }: { manifest: Manifest | null }) {
  const time = manifest ? timeFormat.format(new Date(manifest.generatedAt)) : null;
  return (
    <div className="offline-banner" role="status">
      <WifiOff {...ICON} />
      <Hint text={time ? t.pwa.offline(time) : t.pwa.offlineNoData} content={t.pwa.offlineHint} />
    </div>
  );
}

/** 新版本提示：按下才重新整理，不會自動打斷正在看的內容 */
export function UpdateToast({ onApply }: { onApply: () => void }) {
  return (
    <div className="update-toast" role="status">
      <span>{t.pwa.updateReady}</span>
      <button type="button" className="btn btn-primary" onClick={onApply}>
        <RefreshCw {...ICON} />
        {t.pwa.updateAction}
      </button>
    </div>
  );
}

/** 安裝按鈕：瀏覽器提供安裝提示時直接安裝；iOS 說明「加入主畫面」；已安裝時不顯示 */
export function InstallButton({ pwa }: { pwa: Pwa }) {
  if (pwa.canInstall) {
    return (
      <button type="button" className="install-btn" onClick={() => void pwa.install()}>
        <Download {...ICON} />
        <span>
          <strong>{t.pwa.install}</strong>
          <small>{t.pwa.installDesc}</small>
        </span>
      </button>
    );
  }
  if (pwa.iosInstallHint) {
    return (
      <Hint content={t.pwa.iosInstallHint}>
        <button type="button" className="install-btn">
          <Download {...ICON} />
          <span>
            <strong>{t.pwa.iosInstall}</strong>
            <small>{t.pwa.installDesc}</small>
          </span>
        </button>
      </Hint>
    );
  }
  return null;
}
